import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import Assistant from "./tabs/Assitant";
import ChangePassword from "./tabs/ChangePassword";
import Profile from "./tabs/Profile";
import PurchaseHistory from "./tabs/PurchaseHistory";
import AccountDetailsTab from "../dashboard/teacher/AccountDetailsTab";
import GoogleDriveIntegration from "../dashboard/teacher/GoogleDriveIntegration";
import BackButton from "../../../../components/BackButton/BackButton";
import FloatingAIButton from "../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../state/reducers/chatDrawerReducers";
import StudentSideProfile from "./tabs/StudentSideProfile.jsx";
import ActivityLog from "./tabs/ActivityLog.jsx";
import SettingsIntegrations from "../../../../components/BookAMeeting/SettingsIntegrations.jsx";

function Settings({ isDashboard }) {

  const navigate = useNavigate();
  const location = useLocation();
  const globalState = useSelector((state) => state.globalState);
  const isTeacher = globalState?.role === "Teacher";
  const isStudent = globalState?.role === "Student";
  const isMarketplace = globalState?.enabled_modules?.includes('marketplace');
  const isActivityLogEnabled = globalState?.enabled_modules?.includes('activity_log');
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "profile");
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const dispatch = useDispatch();
  const TabClick = (tab) => {
    setActiveTab(tab);
  };

  const TabLink = ({ activeTab, tabName, label, onClick }) => (
    <li>
      <a
        // href="#"
        className={activeTab === tabName ? "active" : ""}
        onClick={() => onClick(tabName)}
        style={{ cursor: "pointer" }}
      >
        {label}
      </a>
    </li>
  );

  function renderComponent(activeTab) {
    switch (activeTab) {
      case "profile":
        return isTeacher ? <Profile /> : <StudentSideProfile />; 
      case "assistant":
        return <Assistant />;
      case "password":
        return <ChangePassword />;
      case "accountDetails":
        return <AccountDetailsTab />;
      case "integrations":
        return <SettingsIntegrations/>
        // return <GoogleDriveIntegration />;
      case "purchaseHistory":
        return <PurchaseHistory />;
      case "Activitylog":
return   <ActivityLog/>
        return null; // or some default component if none of the cases match
    }
  }
  return (
    <div className="settings_main_sec">
      <Grid
        container
        justifyContent={isDashboard ? "center" : "space-between"}
        alignItems={"flex-end"}
        xs={12}
      >
        {!isDashboard && (
          <div className="msg_sec_new_head ml-5">
            <BackButton buttonName={"Back"} />
          </div>
        )}
        <div className="settings_main_sec_head">
          <ul>
            <TabLink
              activeTab={activeTab}
              tabName="profile"
              label="Profile"
              onClick={TabClick}
            />
            {globalState?.role === "Teacher" && (
              <TabLink
                activeTab={activeTab}
                tabName="assistant"
                label="AI Assistants"
                onClick={TabClick}
              />
            )}
            {/* <TabLink
              activeTab={activeTab}
              tabName="password"
              label="Manage Password"
              onClick={TabClick}
            /> */}
            {isTeacher && isMarketplace && (
              <TabLink
                activeTab={activeTab}
                tabName="accountDetails"
                label="Account Details"
                onClick={TabClick}
              />
            )}
            {isTeacher && isMarketplace && (
              <TabLink
                activeTab={activeTab}
                tabName="integrations"
                label="Integrations"
                onClick={TabClick}
              />
            )}
            {isStudent && isMarketplace && (
              <TabLink
                activeTab={activeTab}
                tabName="purchaseHistory"
                label="Purchase History"
                onClick={TabClick}
              />
            )}
             {isStudent && isActivityLogEnabled && (
              <TabLink
                activeTab={activeTab}
                tabName="Activitylog"
                label="Activity Log"
                onClick={TabClick}
              />
            )}
             {isTeacher && isActivityLogEnabled && (
              <TabLink
                activeTab={activeTab}
                tabName="Activitylog"
                label="Activity Log"
                onClick={TabClick}
              />
            )}
          </ul>
        </div>
        {!isDashboard && <div></div>}
      </Grid>
      <div>{renderComponent(activeTab)}</div>

      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />
    </div>
  );
}

export default Settings;
